import PropTypes from "prop-types";
import { Icon } from "@circle-react-shared/Icon";
import { Tippy } from "@circle-react-shared/Tippy";
import { Typography } from "@circle-react-uikit/Typography";

export const StatItem = ({
  title,
  value,
  tooltipText,
  tooltipIcon = "question-mark",
}) => (
  <div className="border-primary space-y-2 rounded-lg border px-6 py-4">
    <Typography.LabelMd as="h3" weight="medium">
      <div className="flex">
        {title}
        {tooltipText && (
          <Tippy content={tooltipText} className="inline-flex">
            <Icon type={tooltipIcon} className="ml-2" size={16} />
          </Tippy>
        )}
      </div>
    </Typography.LabelMd>
    <Typography.TitleMd as="h4">{value}</Typography.TitleMd>
  </div>
);

StatItem.propTypes = {
  title: PropTypes.node.isRequired,
  value: PropTypes.string.isRequired,
  tooltipText: PropTypes.string,
  tooltipIcon: PropTypes.string,
};
